<div [formGroup]="form">
    <mat-label class="font-style" [ngbTooltip]="boltHoleDiameter_tooltip" placement="right" container="body" tooltipClass="small-tooltip">
        <!-- Bolt Hole Diameter -->
        {{ 'ENGINEERED_JOINT_PAGE.LABELS.CALC_INPUT.BOLT_HOLE_DIAMETER' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #boltHoleDiameter_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.BOLT_HOLE_DIAMETER' | transloco }}
        </p>
    </ng-template>

    <input
        matInput
        class="input-form-class"
        formControlName="boltHoleDiameter"
        name="boltHoleDiameter"
        [ngClass]="form.get('boltHoleDiameter').valid ? '' : 'highLight'"
    />
</div>
